import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return dayjs(iso).format('D MMM YYYY, HH:mm');
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return dayjs(iso).format('D MMM YYYY');
}

export function fromNow(iso: string | null | undefined): string {
  if (!iso) return '—';
  return dayjs(iso).fromNow();
}

/** "11 min", "1 h 4 min", "45 s". */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null) return '—';
  if (seconds < 60) return `${Math.round(seconds)} s`;
  const m = Math.round(seconds / 60);
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${m % 60} min`;
}

/** "Ages 4–7" (en dash, per the design guidelines). */
export function formatAges(min: number, max: number): string {
  return min === max ? `Age ${min}` : `Ages ${min}–${max}`;
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(0)} KB`;
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(1)} MB`;
  return `${(n / 1024 ** 3).toFixed(2)} GB`;
}

export function isFuture(iso: string | null | undefined): boolean {
  return !!iso && dayjs(iso).isAfter(dayjs());
}

/** Date → ISO string (or null) for API bodies. */
export function toIso(d: Date | string | null | undefined): string | null {
  if (!d) return null;
  return dayjs(d).toISOString();
}

export function toDate(iso: string | null | undefined): Date | null {
  return iso ? dayjs(iso).toDate() : null;
}
